import _ from 'lodash';
import { createSelector } from 'reselect';
import { NAME } from './constants';
import * as actionTypes from './actionTypes';
import { selectors as coreSelectors } from '../core';

//users
const getUsersStore = state => state[NAME].users;
const getUsersItems = state => getUsersStore(state).items;
const getUsersByCompanyStore = (state, companyId) => getUsersStore(state).companies[companyId];
const getUsersIds = (state, companyId) =>
    _.get(getUsersByCompanyStore(state, companyId), 'ids', []);
const getUserLoginsStore = state => getUsersStore(state).logins;
const getUserLoginsItems = state => getUserLoginsStore(state).items;

export const getUsersByCompany = createSelector(
    getUsersItems,
    getUsersIds,
    (items, ids) => _.map(ids, id => items[id])
);
export const getUsersPagination = createSelector(
    getUsersByCompanyStore,
    store => _.get(store, 'pagination', {})
);
export const isGettingUsers = (state, companyId) =>
    coreSelectors.isLoadingWithRequestId(state, actionTypes.GET_USERS.NAME, companyId);
export const getUser = (state, userId) => getUsersItems(state)[userId];
export const getUserLogin = (state, userId) => getUserLoginsItems(state)[userId];
export const isLoginingAsUser = (state, userId) =>
    coreSelectors.isLoadingWithRequestId(state, actionTypes.LOGIN_AS_USER.NAME, userId);
export const isUnblockingUser = (state, userId) =>
    coreSelectors.isLoadingWithRequestId(state, actionTypes.UNBLOCK_USER.NAME, userId);
export const isRevokeAllAuthorizations = (state, userId) =>
    coreSelectors.isLoadingWithRequestId(state, actionTypes.REVOKE_ALL_USER_SESSIONS.NAME, userId);
export const isUnlinkingComrceOAuth = (state, userId) =>
    coreSelectors.isLoadingWithRequestId(state, actionTypes.UNLINK_COMRCE_OAUTH.NAME, userId);
export const isDisableTwoFA = (state, userId) =>
    coreSelectors.isLoadingWithRequestId(state, actionTypes.DISABLE_TWO_FA.NAME, userId);

//user activities
const getActivitiesStore = state => state[NAME].activities;
const getActivitiesItems = state => getActivitiesStore(state).items;
const getActivitiesByUserStore = (state, userId) => getActivitiesStore(state).users[userId];
const getActivitiesIds = (state, userId) =>
    _.get(getActivitiesByUserStore(state, userId), 'ids', []);

export const getActivitiesByUser = createSelector(
    getActivitiesItems,
    getActivitiesIds,
    (items, ids) => _.map(ids, id => items[id])
);
export const getActivitiesPagination = createSelector(
    getActivitiesByUserStore,
    store => _.get(store, 'pagination', {})
);
export const isGettingUserActivities = (state, userId) =>
    coreSelectors.isLoadingWithRequestId(state, actionTypes.GET_USER_ACTIVITIES.NAME, userId);
export const getUserActivity = (state, activityId) => getActivitiesItems(state)[activityId];

//allUsers
const getAllUsersStore = state => state[NAME].allUsers;
const getAllUsersItems = state => getAllUsersStore(state).items;
const getAllUsersIds = state => _.get(getAllUsersStore(state), 'ids', []);

export const getUserFromAll = (state, userId) => getAllUsersItems(state)[userId];
export const getAllUsers = createSelector(
    getAllUsersItems,
    getAllUsersIds,
    (items, ids) => _.map(ids, id => items[id])
);
export const getAllUsersPagination = createSelector(
    getAllUsersStore,
    store => _.get(store, 'pagination', {})
);
export const isGettingAllUsers = state =>
    coreSelectors.isLoading(state, actionTypes.GET_ALL_USERS.NAME);

//user notifications
const getNotificationsStore = state => state[NAME].notifications;
const getNotificationsItems = state => getNotificationsStore(state).items;
const getNotificationsByUserStore = (state, userId) => getNotificationsStore(state).users[userId];
const getNotificationsIds = (state, userId) =>
    _.get(getNotificationsByUserStore(state, userId), 'ids', []);

export const getNotificationsByUser = createSelector(
    getNotificationsItems,
    getNotificationsIds,
    (items, ids) => _.map(ids, id => items[id])
);
export const getNotificationsPagination = createSelector(
    getNotificationsByUserStore,
    store => _.get(store, 'pagination', {})
);
export const isGettingUserNotifications = (state, userId) =>
    coreSelectors.isLoadingWithRequestId(state, actionTypes.GET_USER_NOTIFICATIONS.NAME, userId);
export const isSendingNotificationForAll = state =>
    coreSelectors.isLoading(state, actionTypes.CREATE_NOTIFICATION_FOR_ALL.NAME);
export const isSendingNotificationForUsers = state =>
    coreSelectors.isLoading(state, actionTypes.CREATE_NOTIFICATION_FOR_USERS.NAME);
export const isResettingNPSForUsers = state =>
    coreSelectors.isLoading(state, actionTypes.RESET_NEXT_REVIEW_DATE_FOR_USERS.NAME);
